import _ from 'lodash'
import localForage from 'localforage'

import BaseStore from 'api/Base'
import {AuthConstants} from 'api/auth'
import {Actions as NetworkActions} from 'api/network/Constants'

import Service from './Service'
import {Actions} from './Constants'

class DeviceStore extends BaseStore {
   constructor() {
      super()

      this.subscribe(this._subscribe.bind(this))

      this._devices = []
      // use filter to remove undefined items
      localForage.getItem('devices').then(devices => {
         this._devices = _.filter(devices)
      })

      this._columns = ['key', 'network', 'name', 'type', 'address']
   }

   emitChange() {
      localForage.setItem('devices', this._devices).then(() => {
         BaseStore.prototype.emitChange.call(this)
      })
   }

   _subscribe(action) {
      let idx

      switch (action.actionType) {
         case AuthConstants.Actions.logout:
            this._devices = null
            localForage.removeItem('devices')
            this.emitChange()
            break

         case Actions.create:
            this._devices.push(action.device)
            this.emitChange()
            break

         case Actions.change:
            idx = _.findIndex(this._devices, {key: action.key, network: action.nid})

            if (-1 === idx) {
               this._devices.push(action.device)
            } else {
               this._devices[idx] = action.device
            }

            this._collectColumns(action.device, false)

            this.emitChange()
            break

         case Actions.update:
            idx = _.findIndex(this._devices, {key: action.key, network: action.nid})
            if (-1 === idx) {
               return
            }

            this._devices[idx] = _.merge(this._devices[idx], action.device)
            this._collectColumns(action.device, false)
            this.emitChange()
            break

         case NetworkActions.change:
            if (action.network.devices) {
               Service.list(action.network.key)
            }

            break

         case NetworkActions.list:
            // _.each(action.networks, net => Service.list(net.key))
            break

         case Actions.list:
            this._devices = _.uniq(
               action.devices.concat(this._devices || []),
               dev => dev.network + '/' + dev.key,
            )

            _.each(this._devices, this._collectColumns, this)

            this.emitChange()
            break

         default:
            break
      }
   }

   _collectColumns(dev, allowEmit) {
      const collectPaths = ([path, acc], v, k) => {
         const realpath = !k ? path : path.concat([k])

         if (_.isObject(v) && !_.isArray(v)) {
            _.each(v, (v2, k2) => collectPaths([realpath, acc], v2, k2))

            return [path, acc]
         } else {
            if (-1 === acc.indexOf(realpath)) {
               acc.push(realpath.slice(1).join('.'))
            }

            return [path, acc]
         }
      }

      let cols = collectPaths([[], []], dev, '.')[1],
         newCols = _.without.apply(this, [cols].concat(this._columns))

      if (0 < newCols.length) {
         this._columns = this._columns.concat(newCols)
         if (true === allowEmit) {
            this.emitChange()
         }

         return true
      } else {
         return false
      }
   }

   facets(paths) {
      return _.reduce(
         this._devices,
         (acc, dev) =>
            _.reduce(
               paths,
               (acc2, p) => {
                  let newpaths = _.uniq([_.get(dev, p, undefined)].concat(acc2[p] || []))

                  acc2[p] = newpaths

                  return acc2
               },
               acc,
            ),
         {},
      )
   }

   get columns() {
      return this._columns
   }

   devices(nid) {
      return _.where(this._devices, {network: nid})
   }

   device(nid, key) {
      return _.where(this._devices, {network: nid, key: key})[0]
   }
}

export default new DeviceStore()



// WEBPACK FOOTER //
// lib/api/device/Store.js